<template>
  <div class="md:min-h-screen flex justify-center items-center flex-col">
    <TokenInvalid v-if="tab == -2"/>
    
    <LoanLoadingForm v-if="tab == -1" />

    <div v-else-if="tab == 0" class="" style="border-radius: 8px;">
      <ReviewForm
          :guarantor="guarantor"
      />
    </div>
  </div>
</template>

<script>
import {verifyToken} from "@/api/auth";
import Ripple from '@/components/Ripple';
import ReviewForm from "@/components/loan/guarantorReviewForm";
import LoanLoadingForm from "@/components/loan/loading";
import TokenInvalid from "@/components/TokenInvalid.vue";

export default {
  components: {
    TokenInvalid,
    Ripple,
    LoanLoadingForm,
    ReviewForm,
  },
  data() {
    return {
      tab: -1,
      guarantor: {
        signature: null,
        email: "",
        phone: "",
        name: "",
        address: "",
        occupation: "",
        occupation_others: "",
        business_address: "",
        documents: {},

        bvn: "",
        nin_phone: "",
        nin_dob: "",
        nin_verification_type: "",

        "loan_id": "",
        "loan_amount": 0,
        "customer_email": "",
        "customer_name": "",
        "customer_address": "",

        "date": "",
      },
    }
  },

  methods: {
    async fetchUserDetails() {
      const {token} = this.$route.query;

      this.isLoading = true;
      try {
        let response = await verifyToken({userToken: token});
        this.guarantor = {
          ...this.guarantor,
          ...response.data.data,
          occupation: response.data.data.occupation,
          documents: response.data.data.document_to_upload
              ?.split(",")
              .reduce((acc, curr) => ({
                ...acc,
                [curr]: null
              }), {}) ?? {},
        }

        this.tab = 0;
      } catch (e) {
        this.tab = -2;
      } finally {
        this.isLoading = false;
      }
    }
  },
  mounted() {
    this.fetchUserDetails();
  }
}
</script>
